<template>
  <form v-on:input="handleFormChanges">
    <div class="form-group type-align-center add-large-top-margin">
      <label for="lowestPrice" class="type-label"><span v-text="step.formLabelLowest"></span> (<span v-text="currency"></span>)</label>
      <div class="form-control form-control--currency display-inline-block">
        <input type="text"
          ref="lowest"
          v-model="step.prices.lowest"
          v-validate="'required|decimal:2'"
          name="lowest price"
          id="lowestPrice"
          :placeholder="step.formLabelLowest">
      </div>
    </div>
    <div class="form-group type-align-center">
      <label for="highestPrice" class="type-label"><span v-text="step.formLabelHighest"></span> (<span v-text="currency"></span>)</label>
      <div class="form-control form-control--currency display-inline-block">
        <input type="text"
          v-model="step.prices.highest"
          v-validate="`required|decimal:2|min_value:${step.prices.lowest}`"
          name="highest price"
          id="highestPrice"
          :placeholder="step.formLabelHighest">
      </div>
    </div>
    <p>&nbsp;<span v-if="errors.has('highest price') || errors.has('lowest price')" class="type-small error-message display-inline-block" v-text="errors.items[0].msg"></span></p>
  </form>
</template>

<script>
const debounce = require('lodash').debounce;

export default {
  name: 'LicenceEstimatorTicketPrice',
  props: {
    step: {
      required: true,
      type: Object,
    },
    currency: {
      required: true,
      type: String,
    },
  },
  mounted() {
    this.$refs.lowest.focus();
    if (this.step.prices.lowest.length > 0 && this.step.prices.highest.length > 0) {
      this.handleFormChanges();
    }
  },
  methods: {
    handleFormChanges() {
      debounce(() => {
        this.$validator.validateAll().then((result) => {
          if (result) {
            return this.$emit('formValid');
          }

          this.$emit('formInvalid');
        }).catch(() => this.$emit('formInvalid'));
      }, 200)();
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Estimator/LicenceEstimatorTicketPrice.vue